/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DraftMeta } from './DraftMeta';
import { LinkedRef } from './LinkedRef';
import { LinkedResourceRef } from './LinkedResourceRef';

export const Draft: core.serialization.ObjectSchema<serializers.Draft.Raw, Truvity.Draft> = core.serialization.object({
    jsonLdVocabs: core.serialization.property(
        'json_ld_vocabs',
        core.serialization.list(core.serialization.string()).optional(),
    ),
    linkedCredentialRefs: core.serialization.property(
        'linked_credential_refs',
        core.serialization.list(LinkedRef).optional(),
    ),
    linkedDraftRefs: core.serialization.property(
        'linked_draft_refs',
        core.serialization.list(LinkedResourceRef).optional(),
    ),
    meta: DraftMeta.optional(),
    metaSchema: core.serialization.property('meta_schema', core.serialization.string()),
    type: core.serialization.list(core.serialization.string()),
    values: core.serialization.lazy(() => serializers.CredentialClaimValues).optional(),
    vcdmJsonSchemas: core.serialization.property(
        'vcdm_json_schemas',
        core.serialization.list(core.serialization.string()).optional(),
    ),
});

export declare namespace Draft {
    export interface Raw {
        json_ld_vocabs?: string[] | null;
        linked_credential_refs?: LinkedRef.Raw[] | null;
        linked_draft_refs?: LinkedResourceRef.Raw[] | null;
        meta?: DraftMeta.Raw | null;
        meta_schema: string;
        type: string[];
        values?: serializers.CredentialClaimValues.Raw | null;
        vcdm_json_schemas?: string[] | null;
    }
}
